import { jsx as _jsx } from "react/jsx-runtime";
import { TableView } from '../../../infra/ui/table/table-default';
export var ShopUsersList = function (props) {
    if (props.loading) {
        return (_jsx("div", { className: "u-pl u-mb-", children: _jsx("div", { className: "c-loader c-loader--inline", children: _jsx("div", { className: "c-loader__spin" }) }) }));
    }
    return _jsx(TableView, { table: props.table, paginated: false });
};
